import { z } from "zod";
import { ControlDataTypeKey, Types } from "../prop-controllers";
import { P, match } from "ts-pattern";
const videoDataSchema = z.object({
  url: z.string().optional(),
  muted: z.boolean().optional(),
  playing: z.boolean().optional(),
  loop: z.boolean().optional(),
  controls: z.boolean().optional()
});
const videoPropControllerDataV0Schema = videoDataSchema;
const VideoPropControllerDataV1Type = "prop-controllers::video::v1";
const videoPropControllerDataV1Schema = z.object({
  [ControlDataTypeKey]: z.literal(VideoPropControllerDataV1Type),
  value: videoDataSchema
});
const videoPropControllerDataSchema = z.union([
  videoPropControllerDataV1Schema,
  videoPropControllerDataV0Schema
]);
function Video(options = {}) {
  return { type: Types.Video, version: 1, options };
}
function getVideoPropControllerDataVideoData(data) {
  return match(data).with(
    { [ControlDataTypeKey]: VideoPropControllerDataV1Type },
    (v1) => v1.value
  ).otherwise((v0) => v0);
}
function createVideoPropControllerDataFromVideoData(value, definition) {
  return match(definition).with(
    { version: 1 },
    P.nullish,
    () => ({
      [ControlDataTypeKey]: VideoPropControllerDataV1Type,
      value
    })
  ).otherwise(() => value);
}
export {
  Video,
  VideoPropControllerDataV1Type,
  createVideoPropControllerDataFromVideoData,
  getVideoPropControllerDataVideoData,
  videoPropControllerDataSchema
};
//# sourceMappingURL=video.js.map